import isEmpty from 'lodash/isEmpty';

class InvoiceBookingHelper {
  constructor(invoiceData) {
    this.invoiceData = invoiceData;
    this.name = invoiceData.invoiceCompany;
    this.address = invoiceData.invoiceAddress;
    this.taxNumber = invoiceData.invoiceTaxNumber;
    return this;
  }

  sendInvoice() {
    return this.isWholeFilled();
  }

  isPartialEmptyForm = () => {
    return isEmpty(this.name) ||
      isEmpty(this.address) ||
      isEmpty(this.taxNumber);
  }

  isEmptyForm = () => {
    return isEmpty(this.name) &&
      isEmpty(this.address) &&
      isEmpty(this.taxNumber);
  }

  isWholeFilled = () => {
    return !isEmpty(this.name) &&
      !isEmpty(this.address) &&
      !isEmpty(this.taxNumber);
  }
}

export default InvoiceBookingHelper;
